//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SkeletonRect',
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '48px' },
    borderRadius: { type: String, default: '12px' },
    background: { type: String, default: 'rgba(25, 33, 72, 1)' }
  }
};
